export default __webpack_public_path__ + "static/IELTSSlay-2d46396c0f96d594d212dc4b64c38ef7.png";